// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@eisinc/App/SharedStyles/smallHeadingAndTextStyles";
import { productListStyles } from "@eisinc/Overrides/Widgets/OrderConfirmation/OrderConfirmationProductList";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

productListStyles.container = {
    css: css`
        margin-top: 16px;
    `,
};

productListStyles.centeringWrapper = {
    css: css`
        margin-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};

productListStyles.heading = {
    variant: "h4",
    css: css`
        margin-bottom: 12px;
    `,
};

productListStyles.smallHeadingAndText = {
    ...createHorizontalSmallHeadingAndTextStyles(
        {
            wrapper: {
                css: css`
                    margin-bottom: 12px;
                    width: auto;
                `,
            },
            heading: {
                weight: fontConfig.weight.regular,
                ...fontConfig.singleLineRegular,
                css: css`
                    line-height: ${fontConfig.singleLineRegular.lineHeight};
                `,

            },
            text: {
                weight: fontConfig.weight.medium,
                ...fontConfig.singleLineRegular,
                css: css`
                    line-height: ${fontConfig.singleLineRegular.lineHeight};
                `,
            }
        }
    ),
};
productListStyles.shippingCostWrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
    `,
};
